<script setup lang="ts">
import { computed, useAttrs } from 'vue'
import { Icon } from '@iconify/vue'

interface Props {
  iconCls?: string
}

defineProps<Props>()

const attrs = useAttrs()

const bindAttrs: any = computed<{ class: string; style: string }>(() => ({
  class: (attrs.class as string) || '',
  style: (attrs.style as string) || '',
}))
</script>

<template>
  <Icon
    class="loto-icon loto-left"
    icon="ant-design:left-outlined"
    v-bind="bindAttrs"
  />
</template>
<style scoped lang="less">
.loto-icon {
  width: 1.3em;
  height: 1.3em;
  vertical-align: -0.3em;
  fill: currentColor;
  overflow: hidden;
}
</style>
